'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _en = require('../intl/en');

var _en2 = _interopRequireDefault(_en);

var _flattenMessages = require('../utils/flattenMessages');

var _flattenMessages2 = _interopRequireDefault(_flattenMessages);

var _getBrowserDataFromUA = require('../utils/getBrowserDataFromUA');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCookieValue(a) {
    var b = typeof document !== 'undefined' && document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

var DEFAULT_ITEMS_TO_SHOW = 24;

var getPageSizeFromCookie = function getPageSizeFromCookie(cookie) {
    return cookie === 'all' ? 'all' : Number(cookie);
};

var getInitialData = function getInitialData() {
    var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { cookies: [], headers: [], hostname: '', url: '' };
    var whiteLabelInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // check the cookie for a valid token
    var token = req.cookies['bidder-auth'] || getCookieValue('bidder-auth') || '';
    var authName = req.cookies['5Xq_name'] || getCookieValue('5Xq_name') || '';
    var authNuid = req.cookies['5Xq_nuid'] || getCookieValue('5Xq_nuid') || '';
    var authVerify = req.cookies['5Xq_nverify'] || getCookieValue('5Xq_nverify') || '';
    var referrer = req.headers.referer || '';
    var userAgent = req.headers['user-agent'] || navigator.userAgent || '';
    var browser = (0, _getBrowserDataFromUA.getBrowserDataFromUA)(userAgent);
    var touchDate = new Date().getTime();
    var flatMessages = (0, _flattenMessages2.default)(_en2.default);
    var dateLastShown = req.cookies['join-modal-last-seen'] || getCookieValue('join-modal-last-seen') || '';
    var hasLoggedInBefore = !!(req.cookies['bidder-has-logged-in'] || getCookieValue('bidder-has-logged-in') || !!token);
    var disableModalForTesting = req.url.includes('hideForTesting') || req.url.includes('/console/');
    var pageSize = getPageSizeFromCookie(req.cookies['pagination-page-size']) || getPageSizeFromCookie(getCookieValue('pagination-page-size')) || DEFAULT_ITEMS_TO_SHOW;

    var whiteLabel = {
        hostname: req.hostname,
        isWhiteLabel: false,
        logo: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
        sellerId: 0
    };

    var optimizer = '';

    var _ref = browser || {},
        _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name;

    optimizer = name.toLowerCase() === 'chrome' ? '?auto=webp&format=pjpg' : '';

    if (whiteLabelInfo) {
        var sellerName = whiteLabelInfo.name,
            sellerId = whiteLabelInfo.sellerId,
            website = whiteLabelInfo.website,
            logoId = whiteLabelInfo.logoId;

        var siteNameMatch = (website || '').match(/^(?:https?:\/\/)?(?:[w]{3}\.)?(.*)$/);
        var siteName = siteNameMatch && siteNameMatch[1].length > 0 ? siteNameMatch[1].replace(/\/+$/, '') : '';

        whiteLabel = {
            hostname: req.hostname,
            isWhiteLabel: true,
            logo: !logoId || logoId === '' ? null : 'https://images.liveauctioneers.com/houses/logos/lg/' + logoId + '_large.jpg' + optimizer,
            name: sellerName,
            sellerId: sellerId,
            siteName: siteName,
            siteUrl: website || ''
        };
    }

    return {
        config: _config2.default,
        intl: {
            defaultLocale: 'en',
            locale: 'en',
            messages: flatMessages
        },
        ui: {
            analytics: {
                referrer: referrer,
                touchDate: touchDate
            },
            autoPopModal: {
                dateLastShown: dateLastShown,
                disableModalForTesting: disableModalForTesting,
                hasLoggedInBefore: hasLoggedInBefore
            },
            browser: browser,
            pagination: {
                pageSize: pageSize
            }
        },
        user: {
            user: { authName: authName, authNuid: authNuid, authVerify: authVerify, token: token, userData: {} }
        },
        whiteLabel: whiteLabel
    };
};

exports.default = getInitialData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/initialData.js
// module id = t5WM
// module chunks = 57